import React, { useEffect, useState } from 'react';
import { Navigate, Routes, Route } from 'react-router-dom';
import { appContext } from '../App';
import DashboardLayoutBasic from './LandingPage';
import CustomerList from './Components/Customer/CustomerList';
import AuthenticationList from './Components/Authentication/AuthenticationList';
import InvoiceList from './Components/Invoices/InvoiceList';
import MonitorHome from './Components/Monitor/MonitorHome';
import DynamicComponentRenderer from './Components/Monitor/DynamicComponentRenderer';
import MachineList from './Components/MachinesModal/MachinesList';
import MachineViewList from './Components/Machines/MachineList';
import PaymentsList from './Components/Payments/PaymentsList';
import ProxySettlementList from './Components/ProxySettlements/ProxySettlementList';
import ReportControl from './Components/FinancialReport/ReportControl';
import SimulatorControll from './Components/Simulator/SimulatorControll';
import Nicehash from './Components/Nicehash/Nicehash';
import CloudOrderSetting from './Components/Nicehash/CloudOrderSetting';
import CloudOrders from './Components/Nicehash/CloudOrders';
import ApiList from './Components/Api/ApiList';
import Wallets from './Components/Wallets/Wallets';
import AccountsControll from './Components/CustomerAccounts/AccountsControll';
import Reseller from './Components/Reseller/Reseller';
import HashBoard from './Components/HashBoard/HashBoard';
import PricePredictionController from './Components/PricePrediction/PricePredictionController';
import PricePredictionSettings from './Components/PricePrediction/PricePredictionSettings';
import Prices from './Components/Sales/Prices';
import ResellerDashboard from './Components/ResellerDashboard/ResellerDashboard';

import AuditControl from './Components/Audit/AuditControl';
import ValidatorControll from './Components/FinancialValidator/ValidatorControll';
import AssetController from './Components/Assets/AssetController';
import HostingSetupController from './Components/HostingSetup/HostingSetupController';
import EqualizerTenantList from './Components/Equalizer/EqualizerTenantList';
import ExternalTenantApiSettings from './Components/Tenants/ExternalTenantApiSettings';
import PartnerController from './Components/Partners/PartnerController';

interface Revalidate {
  validate: () => void;
  user: string;
  authRole: string;
}

function MainView(props: Revalidate) {
  const [isAuthVerified, setIsAuthVerified] = useState<boolean>(true);
  const [authUserName] = useState<string>(props.user);
  const [authRole] = useState<string>(props.authRole)


  useEffect(() => {
    props.validate();
  }, [isAuthVerified]);

  return (
    <appContext.Provider value={{ isAuthVerified, setIsAuthVerified, authUserName, authRole }}>
      <Routes>
        <Route path="/customers" element={<DashboardLayoutBasic children={<CustomerList />} />} />
        <Route path="/invoices" element={<DashboardLayoutBasic children={<InvoiceList />} />} />
        <Route path="/monitor" element={authRole === "ADMIN" && <DashboardLayoutBasic children={<MonitorHome />} />} />
        <Route path="/machines" element={<DashboardLayoutBasic children={<MachineViewList />} />} />
        <Route path="/monitor/:id" element={<DashboardLayoutBasic children={<DynamicComponentRenderer />} />} />
        <Route path="/settings/machines" element={<DashboardLayoutBasic children={<MachineList />} />} />
        <Route path="/settings/authentication" element={<DashboardLayoutBasic children={<AuthenticationList />} />} />
        <Route path="/settings/nicehash/price-configuration" element={<DashboardLayoutBasic children={<Nicehash />} />} />
        <Route path="/settings/cloud-order/settings" element={<DashboardLayoutBasic children={<CloudOrderSetting />} />} />
        <Route path="/settings/cloud-order/orders" element={authRole === "ADMIN" && <DashboardLayoutBasic children={<CloudOrders />} />} />
        <Route path="/settings/nicehash/cloud-order-setting" element={<Navigate to="/settings/cloud-order/settings" replace />} />
        <Route path="/settings/nicehash/cloud-orders" element={<Navigate to="/settings/cloud-order/orders" replace />} />
        <Route path="/settings/reseller" element={<DashboardLayoutBasic children={<Reseller />} />} />
        <Route path="/settings/hostingSetup" element={<DashboardLayoutBasic children={<HostingSetupController />} />} />
        <Route path="/settings/equalizer" element={<DashboardLayoutBasic children={<EqualizerTenantList />} />} />
        <Route path="/settings/external-tenants" element={authRole === "ADMIN" && <DashboardLayoutBasic children={<ExternalTenantApiSettings />} />} />
        <Route path="/settings/partners" element={authRole === "ADMIN" && <DashboardLayoutBasic children={<PartnerController />} />} />
        <Route path="/settings/price-prediction" element={authRole === "ADMIN" && <DashboardLayoutBasic children={<PricePredictionSettings />} />} />
        <Route path="/payments" element={<DashboardLayoutBasic children={<PaymentsList />} />} />
        <Route path="/proxy-settlements" element={<DashboardLayoutBasic children={<ProxySettlementList />} />} />
        <Route path="/report" element={<DashboardLayoutBasic children={<ReportControl />} />} />
        <Route path="/accounts" element={<DashboardLayoutBasic children={<AccountsControll />} />} />
        <Route path="/wallets" element={<DashboardLayoutBasic children={<Wallets />} />} />
        <Route path="/hashboard" element={<DashboardLayoutBasic children={<HashBoard />} />} />
        <Route path="/simulator" element={<DashboardLayoutBasic children={<SimulatorControll />} />} />
        <Route path="/priceprediction" element={<DashboardLayoutBasic children={<PricePredictionController />} />} />
        <Route path="/sales/prices" element={<DashboardLayoutBasic children={<Prices />} />} />
        <Route path="/audit" element={<DashboardLayoutBasic children={<AuditControl />} />} />
        <Route path="/validator" element={authRole === "ADMIN" && <DashboardLayoutBasic children={<ValidatorControll />} />} />
        <Route path="/assets" element={<DashboardLayoutBasic children={<AssetController />} />} />
        <Route path='/apiCalls' element={authRole === "ADMIN" && <DashboardLayoutBasic children={<ApiList />} />} />
        <Route path='/reseller-dashboard' element={<DashboardLayoutBasic children={<ResellerDashboard />} />} />
        <Route path="/" element={<DashboardLayoutBasic children={<span>Welcome</span>} />} />
      </Routes>
    </appContext.Provider>
  );
}

export default MainView;
